<template>
  <div>
    <zx-table
      :tableData="tableData"
      :option="table"
      :page="page"
      @searchSubmit="searchSubmit"
      @handleSelectionChange="handleSelectionChange"
      @delBtn="delBtn"
      @refresh-change="getlist"
      @addSubmit="addSubmit"
      @etidSubmit="etidSubmit"
      @refreshBtn="getlist"
    ></zx-table>
  </div>
</template>

<script>
import xzTable from "@/components/xz-table.vue";
import * as current from "@/api/current.js";
import { _getSessionStore } from "@/utils/storage";
import { tableInShow } from "@/assets/hasShow.js";
export default {
  name: "current-list",
  components: {
    "zx-table": xzTable
  },
  data() {
    return {
      page: {
        total: 1,
        pagerCount: 1,
        currentPage: 1,
        pageSize: 10,
        pageSizes: [1, 3, 10, 20, 30, 40, 50, 100],
        // sizes, prev, pager, next, jumper, ->, total, slot
        // "layout":"prev, pager, next",
        layout: "total, sizes, prev, pager, next, jumper",
        background: true
      },
      table: {
        title: "白名单",
        // 编辑 默认:true;
        editBtn: true,
        // 删除  默认:true;
        delBtn: true,
        index: false,
        // 单选高亮
        current: true,
        column: [
          {
            // 字段
            prop: "name",
            // 列名
            label: "名称",
            // 表单 类型
            type: "input",
            // 是否必须输入
            required: true,
            // 表格是否显示
            hide: true,
            // 倒叙 默认:false;
            sortable: true
          },
          {
            // 字段
            prop: "path",
            // 列名
            label: "路径",
            // 表单 类型
            type: "input",
            // 是否必须输入
            required: true,
            // 表格是否显示
            hide: true
          },
          {
            prop: "update_time",
            label: "跟新时间",
            type: "input",
            addDisplay: false,
            editDisplay: false,
            hide: true,
            width: "180"
          },
          {
            prop: "create_time",
            label: "创建时间",
            addDisplay: false,
            editDisplay: false,
            hide: true
          }
        ]
      },
      tableData: []
      //
    };
  },
  created() {
    this.getlist();
  },
  mounted: function() {
    let menuBtn = _getSessionStore("menuBtn", "JSONStr");
  },
  methods: {
    getlist(e) {
      let that = this;
      let param;
      if (e) {
        that.page = e;
        param = {
          page: e.currentPage,
          limit: e.pageSize
        };
      } else {
        param = {
          page: this.page.currentPage,
          limit: this.page.pageSize
        };
      }

      if (this.searchData) {
        param = {
          page: this.page.currentPage,
          limit: this.page.pageSize,
          ...this.searchData
        };
      }

      current.getCurrent.r(param).then(res => {
        that.tableData = res.list;
        that.page.total = res.total;
      });
    },
    // 添加提交
    addSubmit(form) {
      current.addCurrent.r(form).then(res => {
        this.$message.success("账号" + res.name + "创建成功");
        this.getlist();
      });
    },
    // 编辑
    etidSubmit(form) {
      current.editCurrent.r(form).then(res => {
        if (res.status) this.$message.success("修改成功");
        else this.$message.success("修改失败");
        this.getlist();
      });
    },
    // 删除
    delBtn(form) {
      this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          current.deleteCurrent.r({ id: form.id }).then(res => {
            this.$message({
              type: "success",
              message: "删除成功!"
            });
            this.getlist();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    //   多选
    handleSelectionChange(e) {},
    // 筛选条件
    searchSubmit(e) {
      this.searchData = e;
      if (e) {
        this.page.currentPage = 1;
      }
      this.getlist();
    },
    // 分页器
    refreshChange(e) {
      let that = this;
      setTimeout(() => {
        this.getlist();
      }, 1000);
    }
  }
};
</script>

<style lang="scss" scoped>
.xvue-crud {
  th {
    word-break: break-word;
    color: rgba(0, 0, 0, 0.85);
    background-color: #fafafa;
  }

  .el-dialog {
    text-align: left;
  }

  .formD {
    text-align: left;
  }
}
</style>

<!-- 			getCurrentList(){
				let postData = {
					"page":1,
					  "limit":10
				}
				current.getCurrent(postData).then(res =>{
				})
			} -->
